(() => {
    const initYearlyConsumption = () => {
        const yearlyConsumptionWrap = document.querySelector('.electricity-yearly-consumption');
        if (!yearlyConsumptionWrap) return;

        const yearlyConsumptionInput = yearlyConsumptionWrap.querySelector('input');

        let calculateNoticeTimeout = null;
        const calculateNotice = yearlyConsumptionWrap.querySelector('.electricity-yearly-consumption__notice');
        const notariffs = yearlyConsumptionWrap.querySelector('.electricity-yearly-consumption__notariffs');

        const presets = yearlyConsumptionWrap.querySelectorAll('button.electricity-yearly-consumption__presets-button');

        const tariffChoices = document.querySelectorAll('[data-component="electricity-tariff-choice"]');

        let tariffs = Object.values(tariffChoices).map((tariffChoice) => {
            const tariffData = tariffChoice.dataset;
            return {
                prices: JSON.parse(tariffData.prices),
                bonus: parseFloat(tariffData.bonus),
                element: tariffChoice,
                optionId: tariffData.optionId,
            };
        });

        const formatPrice = (price) => {
            return price.toFixed(2).replace('.', ',') + ' €';
        };

        const updateTariffs = (consumption) => {
            let yearlyConsumptionInputValue = yearlyConsumptionInput.value;
            if (yearlyConsumptionInputValue.length < 3) {
                return;
            }
            clearTimeout(calculateNoticeTimeout);
            notariffs.classList.add('electricity-yearly-consumption__notariffs--hidden');
            calculateNotice.classList.remove('electricity-yearly-consumption__notice--hidden');

            let firstValidTariff;
            let hasTariffSelection = false;
            // Update price for each tariff card and hide if there is no valid level
            tariffs.forEach((tariff) => {
                const matchingPrice = tariff.prices.find(
                    (price) => consumption >= price.consumptionFrom && consumption <= price.consumptionTo
                );
                const tariffInput = tariff.element.querySelector('input');

                if (matchingPrice) {
                    // Store first valid tariff for cases in which the selection has to be reset
                    if (!firstValidTariff) {
                        firstValidTariff = tariff;
                    }

                    if (tariffInput.checked) {
                        hasTariffSelection = true;
                    }
                    tariff.element.parentElement.classList.remove('hidden');

                    const price =
                        ((consumption * matchingPrice.apBrutto) / 100 +
                            matchingPrice.gpBrutto -
                            matchingPrice.bonusDirect -
                            matchingPrice.bonusNewCustomer) /
                        12;
                    tariff.element.querySelector('.electricity-price__monthly').innerText = formatPrice(price);
                } else {
                    // Hide and unselect tariff card if no matching level based on the consumption was found
                    tariff.element.classList.remove('mark--selected-js');
                    tariff.element.parentElement.classList.add('hidden');
                    tariffInput.dataset.checked = 'false';
                    tariffInput.checked = false;
                }
            });

            // Reset selection to first tariff if none is selected
            if (!hasTariffSelection && firstValidTariff) {
                if (!firstValidTariff.closest('.product-order-set').classList.contains('product-order-set--hidden')) {
                    firstValidTariff.element.dispatchEvent(new Event('click', { bubbles: true }));
                }
            }

            calculateNoticeTimeout = setTimeout(function () {
                calculateNotice.classList.add('electricity-yearly-consumption__notice--hidden');

                if (document.querySelectorAll('.tariff-electricity:not(.hidden)').length === 0) {
                    notariffs.classList.remove('electricity-yearly-consumption__notariffs--hidden');
                }
            }, 1000);
        };

        if (yearlyConsumptionInput) {
            yearlyConsumptionInput.addEventListener('keyup', () => {
                updateTariffs(parseInt(yearlyConsumptionInput.value));
            });
            yearlyConsumptionInput.addEventListener('change', () => {
                updateTariffs(parseInt(yearlyConsumptionInput.value));
            });
        }

        presets.forEach((preset) => {
            preset.addEventListener('click', (e) => {
                const button = e.target.closest('button');
                yearlyConsumptionInput.value = button.dataset.value;
                updateTariffs(parseInt(button.dataset.value));
            });
        });
    };

    document.addEventListener('readystatechange', initYearlyConsumption);
})();
